import { COMMON_PATHS, DECISION_PATHS, INDIVIDUAL_PATHS, SURVEY_PAGES, 환급결정확인알림톡_PATH } from '@/lib/constants/paths';
import { SimpleAuthFromType } from '@/lib/types/simple-auth';

export const FROM_TYPE_EVENT_PREFIX: Record<SimpleAuthFromType, string> = {
  lookup: 'simplecert',
  decision: 'decision',
  alimtalk: 'talk-decision',
  'personal-deduction': 'personal-deduction'
} as const;

export const FROM_TYPE_CONFIG: Record<SimpleAuthFromType, FromTypeConfig> = {
  // 환급 첫 조회
  lookup: {
    key: 'lookup',
    eventPrefix: FROM_TYPE_EVENT_PREFIX.lookup,
    confirmPage: {
      nextPath: INDIVIDUAL_PATHS.개인수집및조회
    },
    exitDialog: {
      title: '환급액을 다음에 조회하시겠어요?',
      exitPath: COMMON_PATHS.환급조회목록
    },
    features: {
      hasExitButton: true
    }
  },
  // 환급 결정 확인 - 서비스
  decision: {
    key: 'decision',
    eventPrefix: FROM_TYPE_EVENT_PREFIX.decision,
    confirmPage: {
      nextPath: DECISION_PATHS.환급결정로딩
    },
    exitDialog: {
      title: '환급 결과 확인을 그만두고 나갈까요?',
      exitPath: COMMON_PATHS.환급조회목록
    },
    features: {
      hasExitButton: true
    }
  },
  // 환급 결정 확인 - 알림톡
  alimtalk: {
    key: 'alimtalk',
    eventPrefix: FROM_TYPE_EVENT_PREFIX.alimtalk,
    confirmPage: {
      nextPath: 환급결정확인알림톡_PATH.환급결정로딩
    },
    // 알림톡 타입은 exitDialog 사용 X
    exitDialog: {
      title: '',
      exitPath: ''
    },
    features: {
      hasExitButton: false
    }
  },
  // 환급 인적공제
  'personal-deduction': {
    key: 'personal-deduction',
    eventPrefix: FROM_TYPE_EVENT_PREFIX['personal-deduction'],
    confirmPage: {
      nextPath: COMMON_PATHS.수집_진행중
    },
    exitDialog: {
      title: '인적공제 확인을 그만두고 나갈까요?',
      exitPath: SURVEY_PAGES.인적공제_간편인증필요
    },
    features: {
      hasExitButton: true
    }
  }
} as const;

export interface FromTypeConfig {
  readonly key: SimpleAuthFromType;
  readonly eventPrefix: string;
  readonly confirmPage: {
    readonly nextPath: string;
  };
  readonly exitDialog: {
    readonly title: string;
    readonly exitPath: string;
  };
  readonly features: {
    readonly hasExitButton: boolean;
  };
}
